//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { memo, useEffect, useState } from "react";
import { X } from "lucide-react";
import * as XLSX from "xlsx";

const PreviewModal = memo<{
  isOpen: boolean;
  onClose: () => void;
  url: string;
  name: string;
  type: string;
  file?: File; // Added this to receive the raw file
}>(({ isOpen, onClose, url, name, type, file }) => {
  const [excelHtml, setExcelHtml] = useState<string>("");

 useEffect(() => {
  if (isOpen && isExcel && file) {
    const loadFile = async () => {
      try {
        const data = await file.arrayBuffer();
      
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        
        setExcelHtml(XLSX.utils.sheet_to_html(sheet));
      } catch (error) {
        console.error("Error reading excel file:", error);
      }
    };

    loadFile();
  }
}, [isOpen, file, name, type]);

  if (!isOpen) return null;

  const handleClose = () => {
    setExcelHtml("");
    onClose();
  };

  const isExcel = name.endsWith(".xlsx") || name.endsWith(".xls") || type.includes("sheet");

  return (
    <div className={tw`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50`} onClick={handleClose}>
      <div className={tw`bg-white rounded-lg shadow-xl max-w-5xl w-full h-4/5 mx-4 overflow-hidden flex flex-col`} onClick={(e) => e.stopPropagation()}>
        <div className={tw`flex items-center justify-between p-4 border-b`}>
          <h3 className={tw`text-lg font-semibold text-gray-900 truncate max-w-[80%]`}>{name}</h3>
          <button onClick={handleClose} className={tw`text-gray-500 hover:text-gray-700`}><X size={20} /></button>
        </div>
        <div className={tw`flex-1 overflow-auto p-4 bg-gray-50`}>
          {isExcel ? (
            <div className={tw`bg-white border rounded p-2 shadow-inner overflow-x-auto`}>
              <style>{`
                table { border-collapse: collapse; width: 100%; font-size: 13px; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                tr:nth-child(even) { background-color: #f9f9f9; }
              `}</style>
              <div dangerouslySetInnerHTML={{ __html: excelHtml }} />
            </div>
          ) : type.startsWith("image/") ? (
            <img src={url} alt={name} className={tw`max-w-full max-h-full object-contain mx-auto`} />
          ) : type === "application/pdf" ? (
            <iframe src={url} width="100%" height="100%" style={{ minHeight: "500px" }} title={name} />
          ) : (
            <p className={tw`text-center text-gray-600`}>Preview not available for this file type</p>
          )}
        </div>
      </div>
    </div>
  );
});

PreviewModal.displayName = "PreviewModal";
export { PreviewModal };